/* This is a generated file, do not edit it directly */
import * as Types from '@noah-labs/shared-schema-gql';

import {
  useQuery,
  useInfiniteQuery,
  UseQueryOptions,
  UseInfiniteQueryOptions,
  InfiniteData,
} from '@tanstack/react-query';
import { useAppSyncRequest } from '@noah-labs/fe-shared-data-access-shared';
export type SigningJwtQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SigningJwtQuery = {
  __typename?: 'Query';
  signingJwt: { __typename?: 'JwtToken'; Token: string };
};

export const SigningJwtDocument = /*#__PURE__*/ `
    query signingJwt {
  signingJwt {
    Token
  }
}
    `;

export const useSigningJwtQuery = <TData = SigningJwtQuery, TError = unknown>(
  variables?: SigningJwtQueryVariables,
  options?: Omit<UseQueryOptions<SigningJwtQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<SigningJwtQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<SigningJwtQuery, TError, TData>({
    queryKey: variables === undefined ? ['signingJwt'] : ['signingJwt', variables],
    queryFn: useAppSyncRequest<SigningJwtQuery, SigningJwtQueryVariables>(SigningJwtDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useSigningJwtQuery.getKey = (variables?: SigningJwtQueryVariables) =>
  variables === undefined ? ['signingJwt'] : ['signingJwt', variables];

export const useInfiniteSigningJwtQuery = <TData = InfiniteData<SigningJwtQuery>, TError = unknown>(
  variables: SigningJwtQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SigningJwtQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<SigningJwtQuery, TError, TData>['queryKey'];
  },
) => {
  const query = useAppSyncRequest<SigningJwtQuery, SigningJwtQueryVariables>(SigningJwtDocument);
  return useInfiniteQuery<SigningJwtQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['signingJwt.infinite']
            : ['signingJwt.infinite', variables],
        queryFn: (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteSigningJwtQuery.getKey = (variables?: SigningJwtQueryVariables) =>
  variables === undefined ? ['signingJwt.infinite'] : ['signingJwt.infinite', variables];
